import { DEPLOYMENT_ID_HEADER_NAME } from '@layers/web/constants/skew-protection.ts'

const originalFetch = window.fetch

export default defineNuxtPlugin((nuxtApp) => {
  const { VERCEL_DEPLOYMENT_ID } = nuxtApp.$config.public

  /**
   * Add skew protection header to internal fetches
   */
  const addDeploymentIdToHeaders = (originalHeaders: HeadersInit) => {
    const headers = new Headers(originalHeaders)

    if (
      !VERCEL_DEPLOYMENT_ID ||
      headers.get(DEPLOYMENT_ID_HEADER_NAME) !== null
    ) {
      return originalHeaders
    }

    headers.set('x-deployment-id', VERCEL_DEPLOYMENT_ID)
    return headers
  }

  window.fetch = (...args: Parameters<typeof originalFetch>) => {
    const [url, options = {}] = args

    // Only add to internal routes
    if (typeof url === 'string' && !url.startsWith('http')) {
      options.headers = addDeploymentIdToHeaders(options.headers || {})
    }

    return originalFetch(url, options)
  }
})